<template>
  <div class="box">
      <div class="box-item" v-for="item in messageList" :key="item.userId">
          <div class="item-img" style="cursor: pointer;" @click="handleClick(item.userId)">
              <img v-lazy="$global.imgUrl + item.headPhoto" alt="" v-if="item.headPhoto"/>
              <span v-else>
                <Big width='64' height='64' size='20' :big ='item.realName'/>
              </span>
          </div>
          <div class="item-content">
            <div class="content-name">
                <p class="name-box" style="cursor: pointer;" @click="handleClick(item.userId)">{{item.realName}}</p>
                <p class="title-box">
                    <span style="margin-right: 5px;" v-for="i in item.titleList" :key="i.id">{{i.levelTwo}}</span>
                </p>
            </div>
            <div class="content-unit">{{item.unit}}</div>
            <div class="content-field"><span>研究领域：</span><span style="margin-right: 5px;" v-for="i in item.subjectList" :key="i.id">{{i.levelTwoName}}</span></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    messageList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(id) {
      let routeUrl = this.$router.resolve({
        name: "bjzxdetail",
        query: { title: this.$route.query.title, id },
      });
      window.open(routeUrl.href, "_blank");
    },
  }
}
</script>

<style lang="scss" scoped>
.box {
    display: flex;
    flex-wrap: wrap;
    width: 900px;
    .box-item {
        display: flex;
        padding: 0px 50px 55px;
        width: 450px;
        &:nth-child(2n-1) {
            padding-right: 49px;
            border-right: 1px dotted #DCDCDC; ;
        }
        .item-img {
            width: 64px;
            margin-right: 11px;
            img {
                width: 64px;
                height: 64px;
                border-radius: 32px;
            }
        }
        .item-content {
            width: 275px;
            .content-name {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .name-box {
                    margin-right: 25px;
                    max-width: 140px;
                    font-size: 18px;
                    font-weight: 900;
                    color: #263D78;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .title-box {
                    flex: 1;
                    font-size: 14px;
                    color: #1876F0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .content-unit {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                color: #333;
            }
            .content-field {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 30px;
                font-size: 14px;
                color: #333;
            }
        }
    }
}
</style>